import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SingleSelectComponent } from './single-select/single-select.component';
import { MultipleSelectComponent } from './multiple-select/multiple-select.component';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'fc-generic-select',
  templateUrl: './generic-select.component.html',
  styleUrl: './generic-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SingleSelectComponent, MultipleSelectComponent],
})
export class GenericSelectComponent extends FieldType<FieldTypeConfig> {}
